export default function vega(options = {}) {
    let embed;
    return {
        viewerEffect({ $el }) {
            const els = $el.querySelectorAll('pre>code.language-vega');
            if (els.length === 0)
                return;
            (async () => {
                if (!embed) {
                    embed = await import('vega-embed').then((m) => m.default);
                }
                els.forEach((el) => {
                    try {
                        const pre = el.parentElement;
                        const source = el.innerText;
                        const container = document.createElement('div');
                        container.classList.add('bytemd-vega');
                        pre.replaceWith(container);
                        embed(container, source, options);
                    }
                    catch (err) {
                        // console.error(err);
                    }
                });
            })();
        },
    };
}
